export default "__VITE_ASSET__4OkNiS5Z__"